import React, { Component } from 'react'
import { CircularProgress } from 'material-ui'

class Loading extends Component {
  render() {
    return <CircularProgress size={80} thickness={5} color={'#3fa6c1'} />
  }
}

export { Loading }



// WEBPACK FOOTER //
// ./src/components/common/Loading.js